import styled from '@emotion/styled';

import { COLORS3, MEDIA_QUERY, SPACING } from '../../../styles/emotion';

export const Container = styled.div``;

export const ProgressSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 48px;
`;

export const ProgressStep = styled.div<{ isActive: boolean; isComplete: boolean }>`
  color: ${({ isActive, isComplete }) =>
    isActive || isComplete
      ? `var(--text-primary, ${COLORS3.BLACK_100})`
      : `var(--text-tertiary, ${COLORS3.BLACK_050})`};
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  ${MEDIA_QUERY.MOBILE} {
    flex-direction: column;
  }
`;

export const ProgressIndex = styled.div<{ isActive: boolean; isComplete: boolean }>`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${SPACING.XS};
  border: 1px solid
    ${({ isActive, isComplete }) =>
      isActive || isComplete
        ? `var(--text-primary, ${COLORS3.BLACK_100})`
        : `var(--text-tertiary, ${COLORS3.BLACK_050})`};
  border-radius: 50%;
  background-color: transparent;
  ${({ isComplete, isActive }) =>
    (isComplete || isActive) &&
    `
      background-color: ${
        isActive
          ? `var(--text-primary, ${COLORS3.BLACK_100})`
          : `var(--text-secondary, ${COLORS3.BLACK_050})`
      };
      color: var(--text-invert, ${COLORS3.WHITE_100});
    `}

  ${MEDIA_QUERY.MOBILE} {
    margin-bottom: ${SPACING.XS};
  }
`;

export const Divider = styled.div`
  height: 1px;
  background-color: var(--border-element-color, ${COLORS3.BLACK_030});
  margin: 0 ${SPACING.S16};
  flex: 1 1 auto;
  ${MEDIA_QUERY.MOBILE} {
    margin: -${SPACING.S24} ${SPACING.XS} 0;
  }
`;
